import {GlobalProvider} from "../providers/global/global";

export class BaseService {

  constructor(protected globalProvider: GlobalProvider){

  }

  public convertToUserDocument(doc: any): any {
    delete doc.system;
    doc.userId = this.globalProvider.user.uuid;
    doc.created_by = this.globalProvider.user.firstname + ' ' + this.globalProvider.user.lastname;
    doc.created_at = Date.now();
    return doc;
  }

  public hasUserDeletePermission(doc: any): boolean {
    return !doc.hasOwnProperty('system') && doc.hasOwnProperty('ownerId') && doc.ownerId === this.globalProvider.user.uuid;
  }

  public hasUserEditPermission(doc: any): boolean {
    return !doc.hasOwnProperty('system') && doc.hasOwnProperty('ownerId') && doc.ownerId === this.globalProvider.user.uuid;
  }
}



// WEBPACK FOOTER //
// ./src/store/base.service.ts